export enum ErpPositionInvoiceKind {
  STANDARD = 'STANDARD',
  TEILRECHNUNG = 'TEILRECHNUNG',
  SCHLUSSRECHNUNG = 'SCHLUSSRECHNUNG',
  ANZAHLUNGSRECHNUNG = 'ANZAHLUNGSRECHNUNG',
}
